import AddIcon from '@mui/icons-material/Add';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
  Button,
  ButtonBase,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import cx from 'classnames';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import i18n from 'FRONTEND/utils/i18n';

/**
 * Patient information card on top of sidebar.
 */
const PatientProfile = ({
  title,
  gender,
  birthdate,
  picture,
  weight,
  height,
  bmi,
  clientId,
  tenantName,
  workflows,
  share,
  createLabel,
}) => {
  const isExtended = useSelector((state) => state.sidePanel.isExtended);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  // Properly format the patient age.
  const getAge = (birthdate) => {
    if (!birthdate) {
      return;
    }
    const age = dayjs().diff(birthdate, 'years');
    switch (age) {
      case 0: return '< ' + i18n._('1 year old');
      case 1: return i18n._('1 year old');
      default: return age + ' ' + i18n._('years old');
    }
  };

  const getDob = (birthdate) => {
    if (!birthdate) {
      return;
    }
    const day = dayjs(birthdate).format('DD');
    const month = dayjs(birthdate).format('MMMM');
    const year = dayjs(birthdate).format('YYYY');
    return i18n._('Born on') + ` ${day} ${month.charAt(0).toUpperCase() + month.slice(1)} ${year}`;
  };

  const getGender = () => {
    switch (gender) {
      case 'F': return <i className='patientProfile-genderIcon patientProfile-genderIcon_F fas fa-venus' />;
      case 'M': return <i className='patientProfile-genderIcon patientProfile-genderIcon_M fas fa-mars' />;
      case 'NA': return <i className='patientProfile-genderIcon patientProfile-genderIcon_NA fas fa-venus-mars' />;
    }
  };

  const handleDropDownClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const classes = cx('patientProfile', {
    patientProfile_extended: isExtended,
  });

  return (
    <div className={classes}>
      <div className='patientProfile-info'>
        <ButtonBase className='patientProfile-titleLink' href={title.href} data-pjax>
          <img className='patientProfile-titleLinkImage' src={picture} alt={title.label} title={title.label} />
        </ButtonBase>
        {isExtended && <Typography variant='h5' className='patientProfile-patientName'>{title.label} {getGender()}</Typography>}
        {isExtended && (birthdate || gender) && <Typography variant='h6' className='patientProfile-patientAge'>{getAge(birthdate)} ({getDob(birthdate, gender)})</Typography>}
        {isExtended && (weight?.value || height?.value) && <Typography variant='h6' className='patientProfile-patientAge'>{weight.value}{weight.unit} {height.value}{height.unit} </Typography>}
        {isExtended && bmi?.value && <Typography variant='h6' className='patientProfile-patientAge'>{bmi.label} : {bmi.value}</Typography>}
        {isExtended && tenantName && <Typography variant='h6' className='patientProfile-patientId'>{tenantName}</Typography>}
        {isExtended && clientId && <Typography variant='h6' className='patientProfile-patientId'>{clientId}</Typography>}
      </div>

      {(workflows?.length > 0 || share.href) &&
        <div className='patientProfile-actionButtons'>
          {workflows?.length === 1 &&
            <Button
              component='a'
              href={workflows[0].href}
              data-pjax
              className='patientProfile-button'
              variant='contained'
              fullWidth
            >
              <AddIcon className='patientProfile-buttonIcon' titleAccess={createLabel} />
              {isExtended && workflows[0].label}
            </Button>}
          {workflows?.length > 1 &&
            <>
              <Button
                onClick={handleDropDownClick}
                className='patientProfile-button'
                variant='contained'
                fullWidth
              >
                {isExtended ? [<AddIcon className='patientProfile-buttonIcon' key={1} />, createLabel, <KeyboardArrowDownIcon key={2} />] : <AddIcon className='patientProfile-buttonIcon' titleAccess={createLabel} />}
              </Button>
              <Menu
                open={Boolean(menuAnchorEl)}
                anchorEl={menuAnchorEl}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                disableAutoFocusItem
              >
                {workflows.map(({ id, label, href }) => (
                  href &&
                    <MenuItem
                      key={id}
                      component='a'
                      href={href}
                      data-pjax
                    >
                      {label}
                    </MenuItem>
                ))}
              </Menu>
            </>}
          {share.href &&
            <Button
              component='a'
              href={share.href}
              data-pjax
              className='patientProfile-button'
              variant='contained'
              color='inherit'
              fullWidth
            >
              <FolderSharedIcon className='patientProfile-buttonIcon' titleAccess={share.label} />
              {isExtended && share.label}
            </Button>}
        </div>}
    </div>
  );
};

export default PatientProfile;
